// extracted by mini-css-extract-plugin
export default {"app":"Loader_app__IWBiu","main":"Loader_main__PvdSc","loadingtext":"Loader_loadingtext__X+IjC","loadTxt":"Loader_loadTxt__HzYqS","blur-text":"Loader_blur-text__1PJ6C"};